import { LILAC_400, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getContentListItemSpacingHorizontal = (index, numberOfColumn) => {
  if (index % numberOfColumn === numberOfColumn - 1) return {
    marginRight: 0
  };
};
export var getChoronologicalListWidgetStyles = () => {
  var spacing = tokens.spacing,
    borderRadius = tokens.borderRadius;
  return StyleSheet.create({
    container: {
      marginHorizontal: spacing.SPACING_20
    },
    headerListItem: {
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center',
      marginRight: tokens.spacing.SPACING_8
    },
    headerListItemContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    dividerSpacing: {
      marginTop: spacing.SPACING_20,
      marginBottom: spacing.SPACING_8
    },
    contentListItemContainer: {
      flex: 1,
      flexDirection: 'column',
      marginTop: spacing.SPACING_12,
      marginRight: spacing.SPACING_12
    },
    contentListItemTitleContainer: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      minHeight: 18,
      backgroundColor: LILAC_400,
      marginBottom: spacing.SPACING_4,
      borderRadius: borderRadius.BORDER_RADIUS_4
    }
  });
};